import { render, staticRenderFns } from "./simple-diagnosis.vue?vue&type=template&id=4a91dc52&scoped=true"
import script from "./simple-diagnosis.vue?vue&type=script&lang=js"
export * from "./simple-diagnosis.vue?vue&type=script&lang=js"
import style0 from "./simple-diagnosis.vue?vue&type=style&index=0&id=4a91dc52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91dc52",
  null
  
)

export default component.exports